module.exports = __webpack_public_path__ + "img/sapori_foot.64ed908c.jpg";